import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { left: 0, top: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: () => import('@/views/Pages/DashboardPage.vue'),
      meta: {
        title: 'Dashboard',
      },
    },
    {
      path: '/users',
      name: 'Users',
      component: () => import('@/views/Pages/UsersPage.vue'),
      meta: {
        title: 'Users',
      },
    },

    {
      path: '/admin/users/:id/transactions',
      name: 'UserTransactions',
      component: () => import('@/components/users/UserTransactionsPage.vue')
    },
    {
      path: '/admin/users/:id/accounts',
      name: 'UserAccounts',
      component: () => import('@/components/users/UserAccountsPage.vue')
    },
    // {
    //   path: '/accounts',
    //   name: 'Accounts',
    //   component: () => import('@/views/Pages/AccountsPage.vue'),
    //   meta: {
    //     title: 'Accounts',
    //   },
    // },
    {
      path: '/support',
      name: 'Support',
      component: () => import('@/views/Pages/SupportPage.vue'),
      meta: {
        title: 'Support',
      },
    },
    {
      path: '/address-book',
      name: 'Address Book',
      component: () => import('@/views/Pages/AddressBookPage.vue'),
      meta: {
        title: 'Address Book',
      },
    },
    {
      path: '/security-log',
      name: 'Security Log',
      component: () => import('@/views/Pages/SecurityLogsPage.vue'),
      meta: {
        title: 'Security Log',
      },
    },
    {
      path: '/audit-log',
      name: 'Audit Log',
      component: () => import('@/views/Pages/AuditLogsPage.vue'),
      meta: {
        title: 'Audit Log',
      },
    },
    {
      path: '/ledger/overview',
      name: 'Ledger Overview',
      component: () => import('@/components/ledger/ledger_overview'),
      meta: {
        title: 'Ledger Overview',
      },
    }, {
      path: '/ledger/journals',
      name: 'Ledger Journals',
      component: () => import('@/components/ledger/ledger_journals'),
      meta: {
        title: 'Ledger Journals',
      },
    },
    {
      path: '/ledger/accounts_ledger',
      name: 'Accounts Ledger',
      component: () => import('@/components/ledger/accounts_ledger'),
      meta: {
        title: 'Accounts Ledger',
      },
    }, {
      path: '/ledger/audit_logs',
      name: 'Audit Logs',
      component: () => import('@/components/ledger/audit_logs.vue'),
      meta: {
        title: 'Audit Logs',
      },
    },{
      path: '/ledger/system_control',
      name: 'System Control',
      component: () => import('@/components/ledger/system_control.vue'),
      meta: {
        title: 'System Control',
      },
    },
    {
      path: '/admin-experience',
      name: 'Admin Experience',
      component: () => import('@/views/Pages/AdminExperiencePage.vue'),
      meta: {
        title: 'Security Log',
      },
    },
    {
      path: '/security-control',
      name: 'Security Control',
      component: () => import('@/views/Pages/SecurityControlPage.vue'),
      meta: {
        title: 'Security Control',
      },
    },
    {
      path: '/report-analytics',
      name: 'Reporting Analytics',
      component: () => import('@/views/Pages/ReportingAnalyticsPage.vue'),
      meta: {
        title: 'Reporting Analytics',
      },
    },
    {
      path: '/profile',
      name: 'Profile',
      component: () => import('../views/Others/UserProfile.vue'),
      meta: {
        title: 'Profile',
      },
    },
    {
      path: '/site-settings/banners',
      name: 'Home Page Banners',
      component: () => import('@/views/Pages/SettingsBanner.vue'),
      meta: {
        title: 'Home Page Banners',
      },
    },

    {
      path: '/:pathMatch(.*)',
      name: '404 Error',
      component: () => import('../views/Errors/FourZeroFour.vue'),
      meta: {
        title: '404 Error',
      },
    },




    {
      path: '/form-elements',
      name: 'Form Elements',
      component: () => import('../views/Forms/FormElements.vue'),
      meta: {
        title: 'Form Elements',
      },
    },
    {
      path: '/basic-tables',
      name: 'Basic Tables',
      component: () => import('../views/Tables/BasicTables.vue'),
      meta: {
        title: 'Basic Tables',
      },
    },
    {
      path: '/alerts',
      name: 'Alerts',
      component: () => import('../views/UiElements/AlertsView.vue'),
      meta: {
        title: 'Alerts',
      },
    },
    {
      path: '/avatars',
      name: 'Avatars',
      component: () => import('../views/UiElements/AvatarsView.vue'),
      meta: {
        title: 'Avatars',
      },
    },

    {
      path: '/login',
      name: 'Signin',
      component: () => import('../views/Auth/SignIn.vue'),
      meta: {
        title: 'Signin',
      },
    },
    // {
    //   path: '/signup',
    //   name: 'Signup',
    //   component: () => import('../views/Auth/SignUp.vue'),
    //   meta: {
    //     title: 'Signup',
    //   },
    // },
  ],
})

export default router

// router.beforeEach((to, from, next) => {
//   document.title = `Bison Account- ${to.meta.title}`
//
//   const publicPages = ['/login']
//   const authRequired = !publicPages.includes(to.path)
//   const token = localStorage.getItem('admin_token')
//
//   if (authRequired && !token) {
//     return next({ path: '/login' })
//   }
//
//   if (token && publicPages.includes(to.path)) {
//     return next({ name: 'Dashboard' })
//   }
//
//   next()
// })

router.beforeEach((to, from, next) => {
  document.title = `Bison Account - ${to.meta.title}`

  const publicPages = ['/login']
  const authRequired = !publicPages.includes(to.path)
  const token = localStorage.getItem('admin_token')
  const expiresAt = localStorage.getItem('admin_token_expires')

  // اگر توکن هست، ولی منقضی شده → لاگ‌اوت
  if (token && expiresAt) {
    const now = new Date()
    const expireTime = new Date(expiresAt)

    if (now > expireTime) {
      localStorage.removeItem('admin_token')
      localStorage.removeItem('admin_user')
      localStorage.removeItem('admin_token_expires')
      return next({ path: '/login' })
    }
  }

  // اگه نیاز به auth هست ولی توکن نداریم
  if (authRequired && !token) {
    return next({ path: '/login' })
  }

  // اگه توکن داریم و روی صفحه عمومی هستیم → بفرست داشبورد
  if (token && publicPages.includes(to.path)) {
    return next({ name: 'Dashboard' })
  }

  next()
})
